import React from 'react';
import clsx from 'clsx';

export default function UiCard({ title, subtitle, actions, padding = true, children, className }) {
  return (
    <div
      className={clsx(
        'rounded-2xl border border-slate-200/90 bg-white shadow-soft dark:border-slate-700/70 dark:bg-slate-900/70 dark:shadow-none',
        padding && 'p-5 sm:p-6',
        className
      )}
    >
      {(title || subtitle || actions) && (
        <div className={clsx('mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between', padding && 'pb-0')}>
          <div className="min-w-0">
            {title && (
              <h2 className="text-lg font-semibold tracking-tight text-slate-900 dark:text-white">
                {title}
              </h2>
            )}
            {subtitle && <p className="mt-0.5 text-sm text-slate-600 dark:text-slate-400">{subtitle}</p>}
          </div>
          {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
